import React from 'react';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';

import { Row } from '@common/Row';
import { dataControlStore } from '@stores/dataControlStore';

import { GoPreparationOfReportsButton } from '../../GoPreparationOfReportsButton';

import styles from './Title.module.scss';

interface ITitle {
  data: {
    report_package_code_cm?: string;
    ctrl_vers?: string;
    ctrl_vers_ext?: string;
    ctrl_vers_desc?: string;
    status_out?: string;
    ctrl_name?: string;
    user_kp?: string;
    date_kp?: string;
    period_kp?: string;
    exec_num?: string;
  };
}

export const Title = observer(({ data }: ITitle) => {
  const { setInfoDrawer } = dataControlStore;

  return (
    <>
      <p className={styles.title}>Контроли: уровень контроля</p>

      <div className={styles.info}>
        <div className={styles.column}>
          <Row
            name="Код пакета:"
            value={
              <div className={styles.package}>
                {data.report_package_code_cm} <Icon name="info" />{' '}
                <GoPreparationOfReportsButton packageCode={data.report_package_code_cm} />
              </div>
            }
            onClick={() =>
              setInfoDrawer({
                packageCode: data.report_package_code_cm,
                controlDescription: data.ctrl_vers_desc,
                control: data.ctrl_vers ? data.ctrl_vers + (data.ctrl_vers_ext ? ` - ${data.ctrl_vers_ext}` : '') : '',
                ctrlName: data.ctrl_name,
              })
            }
            nameWidth={155}
          />
          <Row
            name="Контроль:"
            value={data.ctrl_vers ? data.ctrl_vers + (data.ctrl_vers_ext ? ` - ${data.ctrl_vers_ext}` : '') : ''}
            nameWidth={155}
          />
          <Row name="Статус прохождения:" value={data.status_out} nameWidth={155} />
          <Row name="Пользователь:" value={data.user_kp} nameWidth={155} />
        </div>

        <div className={styles.column}>
          <Row
            name="Дата и время прохождения КП:"
            value={data.date_kp ? dayjs(new Date(data.date_kp)).format('DD.MM.YYYY HH:mm:ss') : ''}
            nameWidth={230}
          />
          <Row name="Период выполнения КП:" value={data.period_kp} nameWidth={230} />
          <Row name="Порядковый номер запуска КП:" value={data.exec_num} nameWidth={230} />
        </div>

        <div className={styles.largeColumn}>
          <Row
            name="Наименование контроля:"
            value={
              <Tooltip content={data.ctrl_vers_desc} hideOnClick={false} maxWidth={650}>
                <span>{data.ctrl_name || '------------------'}</span>
              </Tooltip>
            }
            nameWidth={185}
          />
        </div>
      </div>
    </>
  );
});
